<template>
  <div>

    <div class="row text-left">

      <div class="col-sm-12 col-md-4 mb-2 align-items-center justify-content-start">
        <div class="dataTables_filter">
          <label class="d-flex mb-0">
            <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1"
              :placeholder="$t('label.search')" v-model="search" @keypress.enter="filterSearch">
            <button
              class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0"
              @click="filterSearch()">
              <i class="fas fa-search"></i>
            </button>
          </label>
        </div>
      </div>

      <div class="col-sm-12 col-md-4 mb-2">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend w-100">
              <label class="input-group-text border-right-0">
                <i class="fas fa-file"></i>
              </label>
              <multiselect
                :value="selectedForm"
                label="title"
                track-by="consentID"
                :options="forms"
                :searchable="true"
                :show-labels="false"
                openDirection="below"
                @select="filterByForm">
                <template slot="option" slot-scope="{ option }">
                  {{ option.title }}
                </template>
              </multiselect>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-12 col-md-4 mb-2">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend w-100">
              <label class="input-group-text border-right-0">
                <i class="fas fa-store"></i>
              </label>
              <multiselect
                :value="selectedOutlet"
                label="text"
                track-by="id"
                :options="outlets"
                :searchable="false"
                :show-labels="false"
                :allow-empty="false"
                openDirection="below"
                @select="filterByOutlet">
                <template slot="option" slot-scope="{ option }">
                  {{ option.text }}
                </template>
              </multiselect>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>

    <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
      {{ $t("table.no_records") }}
    </div>

    <!-- v-if="!isSpinnerShow && totalEntries != 0" -->
    <div class="dataTables_wrapper dt-bootstrap4">

      <div class="row justify-content-end mt-2">
        <div class="col-auto pt-2">
          <span>
            {{ $t('table.pagination', { 'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries, }) }}
          </span>
        </div>
        <div class="col-auto">
          <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries"
            @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
        </div>
      </div>

      <div class="row" v-if="!isSpinnerShow && totalEntries != 0">
        <div class="col-sm-12 overflow-auto">
          <b-table
            striped
            hover
            bordered
            class="apptTable"
            :fields="fields"
            :items="items">
            <template #cell(index)="data">
              {{ data.index + startPage }}
            </template>
            <template #cell(photo)="data">
              <img class="profile-image-md rounded-circle" :src="getMemberImage(data.item)" />
            </template>
            <template #cell(member)="data">
              <div class="font-weight-bold">{{ data.item.member.name }}</div>
              <div>{{ data.item.member.mobile }}</div>
            </template>
            <template #cell(form)="data">
              <div class="font-weight-bold">{{ data.item.consent.title }}</div>
            </template>

            <template #cell(createDate)="data">
              <div>{{ getDateTime(data.item.createDate) }}</div>
            </template>
            <template #cell(outlet)="data">
              <div>{{ getOutlet(data.item) }}</div>
            </template>
            <template #cell(action)="data">
              <b-button
                @click="onDataEdit(data.item)"
                tabindex="0"
                variant="outline-primary">
                <i class="fal fa-eye"></i>
              </b-button>
              <b-button
                @click="showDeleteModal(data.item)"
                tabindex="1"
                variant="outline-danger"
                class="ml-2">
                <i class="fal fa-trash"></i>
              </b-button>
            </template>
          </b-table>
        </div>
      </div>

    </div>

    <div :class="{ 'show': toggleModal }" class="modal fade">
      <div class="modal-dialog modal-lg modal-max modal-dialog-centered">
        <div class="modal-content" style="height: 95vh">
          <div class="modal-header border-bottom">
            <h5 class="modal-title h4 text-capitalize">
              {{ sTitle }}
            </h5>
            <button type="button" class="close" @click="toggleModal = false">
              <span aria-hidden="true"><i class="fal fa-times"></i></span>
            </button>
          </div>
          <div class="modal-body" style="height: 80%; max-height: 100vh">
            <iframe
              :src="consentURL"
              style="width: 100%; height: 95%">
            </iframe>

            <button type="button" class="btn btn-primary" @click="openForm"> Open </button>
            <button v-show="canShareForm" type="button" class="btn btn-success ml-2" @click="shareForm"> Share </button>

            <!-- <a :href="mconsent.url">{{ mconsent.url }}</a> -->
          </div>
          <div class="modal-footer">
            <div class="row w-100 no-gutters">
              <div class="col-auto">
                <button
                  type="button"
                  class="btn btn-danger waves-effect waves-themed mr-2"
                  @click="showDeleteModal(mconsent)">
                  Delete
                </button>
              </div>

              <div class="col">
              </div>
              <div class="col-auto">
                <button
                  type="button"
                  class="btn btn-secondary waves-effect waves-themed ml-2"
                  @click="toggleModal = false">
                  {{ $t('button_link.cancel') }}
                </button>
                <!-- <button
                  v-if="mconsentID ? false : true"
                  type="button"
                  class="btn btn-primary waves-effect waves-themed ml-2"
                  @click="submitForm"
                  :disabled="saveable">
                  Save
                </button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <deleteModal ref="deleteModal" @performConfirmAction="deleteFile"></deleteModal>

  </div>
</template>
<script>
import moment from "moment";
import DeleteModal from './../../Delete_Modal.vue'
import {
  handleSessionExpired,
  setReturnData,
  getMemberMap,
} from "./../../../../assets/js/dashboard/dashboard";
export default {
  name: "ConsentListView",
  components: {
    DeleteModal,
  },
  data() {
    return {
      isSpinnerShow: false,

      search: '',
      filterObj: {},
      outlets: [{ id: '', text: 'All Outlets' }],
      selectedOutlet: {},
      forms: [{ consentID: '', title: 'All Consent Forms' }],
      selectedForm: {},
      memberMap: {},
      outletMap: {},
      duplicateCity: false,

      items: [],
      mconsent: {},
      consentURL: '',
      canShareForm: false,

      page: 0,
      totalEntries: 0,
      totalPage: 0,
      startPage: 1,
      endPage: 0,
      perPage: 100,
      currentPage: 1,

      exportHeaders: [],
      exportData: [],
      exportFileName: "",

      toggleModal: false,
      sTitle: '',
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "photo",
          label: 'Photo',
          thClass: "thead-themed align-middle",
          tdClass: "align-middle text-center",
          sortable: false,
        },
        {
          key: "member",
          label: 'Member',
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
          sortable: false,
        },
        {
          key: "form",
          label: 'Form Signed',
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "createDate",
          label: 'Signed Date',
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "outlet",
          label: 'Outlet',
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "action",
          label: " Action",
          thClass: "thead-themed align-middle",
          tdClass: " align-middle text-center",
        },
      ];
    },
    exportField() {
      var ret = {};
      ret["#"] = "index";
      ret[this.$i18n.t("table.header.name").toUpperCase()] = "name";
      ret[this.$i18n.t("table.header.username").toUpperCase()] = "username";
      ret[this.$i18n.t("table.header.outlet").toUpperCase()] = "outlet";
      ret[this.$i18n.t("table.header.working_hour").toUpperCase()] = "duration";
      ret[this.$i18n.t("table.header.clock_in").toUpperCase()] = "entryDate";
      ret[this.$i18n.t("table.header.clock_out").toUpperCase()] = "exitDate";
      return ret;
    },
  },
  watch: {
    "$i18n.locale"(val) {
      this.setExportData(this.exportData);
    },
  },
  methods: {
    getDateTime(date) {
      let temp = moment.unix(date)
      return temp.format('hh:mma DD/MM/YYYY')
    },
    getMemberImage(data) {
      let member = this.memberMap[data.member.memberID]
      if (member && member.icon) {
        return member.icon
      }
      return require('@/assets/image/icon/profile.png')
    },
    getOutlet(data) {
      let outlet = this.outletMap[data.outletID]
      if (outlet) {
        if (this.duplicateCity) {
          return outlet['city'] + ' [' + outlet['username'] + ']'
        } else {
          return outlet['city']
        }
      }
      return ''
    },

    filterSearch() {
      this.setItems()
    },
    filterByOutlet(val) {
      this.selectedOutlet = val
      this.setItems()
    },
    filterByForm(val) {
      this.selectedForm = val
      this.setItems()
    },

    async loadMembers() {
      this.memberMap = await getMemberMap(this)
    },
    async loadForms() {
      let $vm = this;
      await $vm
        .$axios({
          method: "get",
          url: 'https://bebusiness.tunai.io/consent',
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          var result = response.data.consents.sort((a, b) => b['createDate'] - a['createDate'])
          this.forms = this.forms.concat(result)
          this.selectedForm = this.forms[0]
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
    },
    async loadOutlets() {
      let $vm = this;
      await $vm
        .$axios({
          method: "get",
          url: 'https://m5.tunai.io/business/outlet',
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          var result = response.data.outlets

          let cityCheck = []
          for (let outlet of result) {
            this.outletMap[outlet['outletID']] = outlet

            if (cityCheck.includes(outlet['city'])) {
              this.duplicateCity = true
            }

            cityCheck.push(outlet['city'])
          }
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
    },

    async setItems(filterObj) {
      this.filterObj = filterObj;

      this.isSpinnerShow = true;

      let url = 'https://bebusiness.tunai.io/mconsent?1=1'

      if (this.search) {
        url += '&search=' + this.search
      }

      if (this.selectedOutlet && this.selectedOutlet.id) {
        url += '&outletID=' + this.selectedOutlet.id
      }

      if (this.selectedForm && this.selectedForm.consentID) {
        url += '&consentID=' + this.selectedForm.consentID
      }

      let $vm = this;
      await $vm
        .$axios({
          method: "get",
          url: url,
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          var result = response.data.mconsents.sort((a, b) => b['createDate'] - a['createDate'])

          var retData = setReturnData(result, response.data.total, $vm.page)
          $vm.items = retData.result
          $vm.totalEntries = response.data.count;
          $vm.totalPage = retData.totalPage;

          $vm.startPage = retData.startPage;
          $vm.endPage = retData.endPage;
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      this.isSpinnerShow = false;
    },

    async handlePagination(pg) {
      if (pg != null) {
        this.page = pg - 1;
        await this.setItems(this.filterObj);
      }
    },
    onDataEdit(item) {
      this.mconsent = item
      this.toggleModal = true
      this.sTitle = item['member']['name'] + ' - ' + item['consent']['title']

      // this.consentURL = item.url.replace('https://img.tunai.io', 'https://localhost:5001')
      this.consentURL = item.url.replace('https://img.tunai.io', 'https://mall.tunai.io')

      try {
        let temp = {
          title: this.sTitle,
          url: this.consentURL,
        }

        if (this.$window.navigator.canShare !== null && this.$window.navigator.share !== null) {
          if (this.$window.navigator.canShare(temp)) {
            this.canShareForm = true
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    showDeleteModal(item) {
      this.mconsent = item
      var title = this.$i18n.t('header.delete_file')
      var message = this.$i18n.t('message.confirmation.delete_file')
      this.$refs.deleteModal.showModal(title, message)
    },

    async deleteFile() {
      let $vm = this;
      await $vm
        .$axios({
          method: "post",
          url: 'https://member.tunai.io/business/member/' + this.mconsent.member.memberID + '/mconsent/' + this.mconsent.mconsentID + '/delete',
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          var result = response.data.outlets
          this.$refs.deleteModal.toggleModal = false
          this.toggleModal = false
          this.setItems()
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
    },

    openForm() {
      window.open(this.consentURL, '_blank')
    },
    shareForm() {
      try {
        let temp = {
          title: this.sTitle,
          url: this.consentURL,
        }

        this.$window.navigator.share(temp);
      } catch (e) {
        console.log(e)
      }
    },
  },
  mounted() {
    this.outlets = this.outlets.concat(JSON.parse(this.$store.state.outlets))
    this.selectedOutlet = this.outlets[0]

    this.loadOutlets()
    this.loadMembers()
    this.loadForms()

    this.setItems()
  },
};
</script>
